/**
 * API helpers for business-wide frontend migration owner actions.
 */
import { backend_url } from "@/constants";
import { AXIOS_CONFIG } from "@/utils/api";
import axios, { isAxiosError } from "axios";

import type { BusinessFrontendMode } from "@smartwiz/shared-types";

export class FrontendMigrationContractRequiredError extends Error {
  /** Create an error when intake migration requires an active contract. */
  constructor(message: string) {
    super(message);
    this.name = "FrontendMigrationContractRequiredError";
  }
}

export async function postFrontendModeChoice<
  Mode extends Extract<BusinessFrontendMode, "legacy" | "intake">,
>(mode: Mode): Promise<Mode> {
  try {
    const response = await axios.post<{
      content: { frontendMode: Mode };
    }>(
      `${backend_url}/api/business/frontend-mode/choice/`,
      { mode },
      AXIOS_CONFIG
    );
    return response.data.content.frontendMode;
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status === 409 &&
      mode === "intake"
    ) {
      const message =
        typeof error.response.data?.message === "string"
          ? error.response.data.message
          : "An active contract is required before switching to intake.";
      throw new FrontendMigrationContractRequiredError(message);
    }
    throw error;
  }
}

export async function postFrontendModeHandoff(
  source: "onboarding_complete" | "onboarding_exit"
): Promise<BusinessFrontendMode> {
  const response = await axios.post<{
    content: { frontendMode: BusinessFrontendMode };
  }>(
    `${backend_url}/api/business/frontend-mode/handoff/`,
    { source },
    AXIOS_CONFIG
  );
  return response.data.content.frontendMode;
}
